export enum S3UploadType {
  PROFILEPIC = 'profile_pic',
  IMAGES = 'images',
}
export enum DeleteRequestStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum CheckinRequestStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum Role {
  USER = 'user',
  ADMIN = 'admin',
}

export enum INotificationType {
  CITY = 'city',
  USER_SPECIFIC = 'user_specific',
  ZIP_CODE = 'zip_code',
}

export enum EMapAddressFormat {
  LOCALITY = 'locality',
  STATE = 'administrative_area_level_1',
}

export enum EQuestType {
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  YEARLY = "yearly",
  ALL_THE_TIME = "all_the_time"
}

export enum EMilestoneActionType {
  BINGO_CARD = 'bingo_card',
  FUN_ACTIVITY = 'fun_activity',
  SUB_ACTIVITY = 'sub_activity',
  QUEST = 'quest',
  TRAIL = 'trail',
  CHECKIN = 'checkin',
  SPECIFIC_BINGO_CARD = "specific_bingo_card",
  SPECIFIC_FUNACTIVITY_CARD = "specific_funactivity_card"
}

export enum ERuleType {
  REPEAT = 'repeat',
  UNIQUE = 'unique',
  TOTAL = 'total',
  CONSECUTIVE_DAYS = 'consecutive_days',
  PHOTO = 'photo'
}

export enum ECardType {
  PUBLIC = "public",
  PRIVATE = "private"
}






